import React from 'react';
import { connect } from 'react-redux';
import ReactAI from 'react-appinsights';
import { loadTabs } from '../../Header/actions';
import ilustracion from '../../../images/ilustracion1.png';
import { openCloseModalGallery } from '../../Main/actions';
import { LandingVideo } from './landing';
import LandingButtonBase from './landing/landing-components-base/LandingButtonBase';
import { paths } from '../../../config/routes';
import apiConfig from '../../../config/api';
import { ClaimButton } from './landing/landing-components-base/ClaimButton';
import { isIframe } from 'helpers/isIframe';
import { fullScreenLoading } from 'components/Acceso/Login/actions';

const banner1Url = 'https://www.achs.cl/portal/modoachs/Paginas/Inicio.aspx';
const banner2Url =
  'https://www.achs.cl/portal/trabajaconnosotros/Paginas/Inicio.aspx?utm_source=banner&utm_medium=web&utm_campaign=reclutamiento';

const ColoredLine = ({ color }) => (
  <hr
    style={{
      color,
      backgroundColor: color,
      height: 1,
    }}
  />
);

class DashBoard extends React.PureComponent {
  constructor(props) {
    super(props);

    props.dispatch(loadTabs('Bienvenido a ACHS Virtual'));

    if (isIframe) {
      props.dispatch(fullScreenLoading(true));
    }
  }

  componentDidMount = () => {
    const page = document.getElementById('content');
    page.style.marginTop = '-62px';
  };

  componentWillUnmount = () => {
    const page = document.getElementById('content');
    page.style.marginTop = '-95px';
  };

  getHomeItems = () => [
    {
      title: 'Trabajador',
      icon: 's',
      text:
        'ACHS Virtual es nuestro nuevo producto donde podrás realizar todas tus gestiones en un solo lugar.',
      onClick: () => {
        this.props.dispatch(
          openCloseModalGallery(
            true,
            [{ img: ilustracion, text: 'Beneficios de ACHS Virtual' }],
            'ACHS Virtual',
          ),
        );
      },
    },
    {
      title: 'Empresa',
      icon: 'u',
      text: 'Te entregamos una gran herramienta para gestionar tu empresa con diversos servicios.',
      onClick: () => {
        this.props.dispatch(
          openCloseModalGallery(
            true,
            [{ img: ilustracion, text: 'Beneficios para los trabajadores' }],
            'Trabajador',
          ),
        );
      },
    },
    {
      title: 'ACHS Virtual',
      icon: 't',
      iconSize: 70,
      text: 'Te entregamos una gran herramienta para gestionar tu empresa con diversos servicios.',
      onClick: () => {
        this.props.dispatch(
          openCloseModalGallery(
            true,
            [{ img: ilustracion, text: 'Beneficios para tu empresa' }],
            'Empresa',
          ),
        );
      },
    },
  ];

  handleClose = () => {
    this.props.dispatch(openCloseModalGallery(false, []));
  };

  formatURL = (URL, token, companyID) => {
    return `${URL}${token}&rut=${companyID}`;
  };

  goToArticle27PageHandler() {
    window.open('https://www.achs.cl/ds-67 ', '_blank');
  }

  render() {
    const items = this.getHomeItems();

    return (
      <React.Fragment>
        <div className='landing-container'>
          <div className='landing-buttons-container'>
            <div className='landing-buttons-row'>
              <LandingButtonBase
                title='Mis Documentos y Certificados'
                description='Descarga los documentos de tus accidentes y enfermedades aquí'
                icon='I'
                buttonClass='dx-landing-button-red'
                iconClass='dx-landing-icon-button-red'
                titleClass=''
                descriptionClass=''
                redirectURL={paths.siniestros}
              />
              <LandingButtonBase
                title='Mis Cursos y Capacitaciones'
                description='Descubre los cursos disponibles aquí'
                icon='('
                buttonClass='dx-landing-button-green'
                iconClass='dx-landing-icon-button-green'
                titleClass=''
                descriptionClass=''
                redirectURL={this.formatURL(
                  apiConfig.capacitacionesUri,
                  localStorage.getItem('AccessToken'),
                  this.props.companyId,
                )}
                newTab={true}
              />
            </div>
            <div className='landing-buttons-row'>
              <LandingButtonBase
                title='Resultados de Exámenes de Salud'
                description='Revisa aquí tus exámenes de vigilancia de la salud y servicio de evaluaciones laborales'
                icon='1'
                buttonClass='dx-landing-button-lightgreen'
                iconClass='dx-landing-icon-button-lightgreen'
                titleClass=''
                descriptionClass=''
                redirectURL={process.env.REACT_APP_EXAMENES_TRAB_URL}
                newTab={true}
                // redirectURL={ process.env.REACT_APP_CERTIFICADOS_URL + localStorage.getItem("AccessToken")}
                // newTab={true}
              />
              <LandingButtonBase
                title='Vincular Nuevo Empleador'
                description='Ingresa a tu nuevo empleador para visualizar todos tus cursos aquí'
                icon='D'
                buttonClass='dx-landing-button-blue'
                iconClass='dx-landing-icon-button-blue'
                titleClass=''
                descriptionClass=''
                redirectURL={paths.solicitudesTrabajador}
              />
            </div>
            <div>
              <ClaimButton
                title={'Libro de sugerencias y reclamos'}
                msg={'Si tienes una sugerencia, reclamo, consulta y/o solicitud ingrésalo aquí'}
              />
            </div>
          </div>

          <div className='landing-info-container'>
            <LandingVideo />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  companyId: state.global.companyId,
  UserInfo: state.global.userData,
  jsonData: state.prestacionesEmpresa.jsonData,
  isOpenModalGallery: state.main.isOpenModalGallery,
  galleryItems: state.main.galleryItems,
  galleryTitle: state.main.galleryTitle,
  currentRoles: state.global.myCompanyRoles,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DashBoard);
ReactAI.withTracking(DashBoard);
